import { render, staticRenderFns } from "./Conceptosam.vue?vue&type=template&id=982e2296"
import script from "./Conceptosam.vue?vue&type=script&lang=js"
export * from "./Conceptosam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports